import * as i0 from "@angular/core";
var ScopedPanelCssService = /** @class */ (function () {
    function ScopedPanelCssService() {
    }
    ScopedPanelCssService.prototype.create = function (panelClassName) {
        var _this = this;
        var hostElement = null;
        var styleElement = null;
        var scopedCss = "";
        var scopeClass = this.createScopeClass(panelClassName);
        var removeStyleElement = function () {
            if (hostElement &&
                styleElement &&
                styleElement.parentNode === hostElement) {
                hostElement.removeChild(styleElement);
            }
            styleElement = null;
        };
        var syncStyleElement = function () {
            if (!hostElement) {
                return;
            }
            if (!scopedCss) {
                removeStyleElement();
                return;
            }
            if (!styleElement) {
                styleElement = hostElement.ownerDocument.createElement("style");
                hostElement.insertBefore(styleElement, hostElement.firstChild);
            }
            styleElement.textContent = scopedCss;
        };
        return {
            hostClass: scopeClass,
            mount: function (element) {
                if (hostElement !== element) {
                    removeStyleElement();
                    hostElement = element;
                    hostElement.classList.add(scopeClass);
                }
                syncStyleElement();
            },
            update: function (css) {
                scopedCss = css ? _this.scopeCssRules(css, "." + scopeClass) : "";
                syncStyleElement();
            },
            destroy: function () {
                removeStyleElement();
                if (hostElement) {
                    hostElement.classList.remove(scopeClass);
                }
                hostElement = null;
            },
        };
    };
    ScopedPanelCssService.prototype.createScopeClass = function (panelClassName) {
        return panelClassName + "--scope-" + Math.random()
            .toString(36)
            .slice(2, 10);
    };
    ScopedPanelCssService.prototype.scopeCssRules = function (css, scopeSelector) {
        return this.scopeCssBlocks(this.removeCssComments(css), scopeSelector);
    };
    ScopedPanelCssService.prototype.scopeCssBlocks = function (css, scopeSelector) {
        var result = "";
        var cursor = 0;
        while (cursor < css.length) {
            var blockStart = css.indexOf("{", cursor);
            if (blockStart === -1) {
                break;
            }
            var selectorText = css.slice(cursor, blockStart).trim();
            var blockEnd = this.findBlockEnd(css, blockStart);
            if (!selectorText || blockEnd === -1) {
                break;
            }
            var blockContent = css.slice(blockStart + 1, blockEnd).trim();
            if (selectorText.indexOf("@media") === 0 ||
                selectorText.indexOf("@supports") === 0) {
                result += selectorText + " { " + this.scopeCssBlocks(blockContent, scopeSelector) + " }\n";
            }
            else if (selectorText.indexOf("@") === 0) {
                result += selectorText + " { " + blockContent + " }\n";
            }
            else {
                result += this.prefixSelectorList(selectorText, scopeSelector) + " { " + blockContent + " }\n";
            }
            cursor = blockEnd + 1;
        }
        return result.trim();
    };
    ScopedPanelCssService.prototype.findBlockEnd = function (css, blockStart) {
        var depth = 0;
        for (var index = blockStart; index < css.length; index++) {
            if (css[index] === "{") {
                depth++;
            }
            else if (css[index] === "}") {
                depth--;
                if (depth === 0) {
                    return index;
                }
            }
        }
        return -1;
    };
    ScopedPanelCssService.prototype.removeCssComments = function (css) {
        return css.replace(/\/\*[\s\S]*?\*\//g, "");
    };
    ScopedPanelCssService.prototype.prefixSelectorList = function (selectorList, scopeSelector) {
        var _this = this;
        var selectors = [];
        var currentSelector = "";
        var parenthesesDepth = 0;
        var bracketDepth = 0;
        for (var index = 0; index < selectorList.length; index++) {
            var character = selectorList[index];
            if (character === "(") {
                parenthesesDepth++;
            }
            else if (character === ")") {
                parenthesesDepth--;
            }
            else if (character === "[") {
                bracketDepth++;
            }
            else if (character === "]") {
                bracketDepth--;
            }
            else if (character === "," &&
                parenthesesDepth === 0 &&
                bracketDepth === 0) {
                selectors.push(currentSelector);
                currentSelector = "";
                continue;
            }
            currentSelector += character;
        }
        if (currentSelector) {
            selectors.push(currentSelector);
        }
        return selectors
            .map(function (selector) { return _this.prefixSingleSelector(selector, scopeSelector); })
            .join(", ");
    };
    ScopedPanelCssService.prototype.prefixSingleSelector = function (selector, scopeSelector) {
        var trimmedSelector = selector.trim();
        if (!trimmedSelector) {
            return trimmedSelector;
        }
        if (trimmedSelector.indexOf(scopeSelector) === 0) {
            return trimmedSelector;
        }
        if (trimmedSelector === "html" ||
            trimmedSelector === "body" ||
            trimmedSelector === ":root" ||
            trimmedSelector === ":host" ||
            trimmedSelector === ":scope" ||
            trimmedSelector === "&") {
            return scopeSelector;
        }
        if (trimmedSelector.indexOf("&") === 0) {
            return trimmedSelector.replace("&", scopeSelector);
        }
        return scopeSelector + " " + trimmedSelector;
    };
    ScopedPanelCssService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ScopedPanelCssService_Factory() { return new ScopedPanelCssService(); }, token: ScopedPanelCssService, providedIn: "root" });
    return ScopedPanelCssService;
}());
export { ScopedPanelCssService };
